import { useDispatch, useSelector } from "react-redux"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { cartolaDepartmentState, changeStatus, onFetchCartolaDepartments, onSetTotalRows } from "../redux/slices/cartolaDepartmentSlice"
import { ApiStatus } from "../types/api/status"
import { CartolaDepartmentAPI } from "../apis/CartolaDepartmentAPI"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"

export const useCartolaDepartmentStore = () => {
    const dispatch = useDispatch()
    const { cartolaDepartments, selectedCartolaDepartment, status, totalRows } = useSelector(cartolaDepartmentState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.data?.idcompany

    const getCartolaDeparments = async (data?: object) => {
        dispatch(dispatch(changeStatus(ApiStatus.FETCHING)))
        try {
            const response = await CartolaDepartmentAPI.get(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || '')

                return false;
            }

            const { detail, total } = response.data

            dispatch(onFetchCartolaDepartments(detail || []))
            dispatch(onSetTotalRows(total || 0))

            return true
        } catch (error) {
            dispatch(changeStatus(ApiStatus.FETCHED))
            console.error(error)

            return false
        }
    }

    const generatePDF = async (iddepartment: number, start_date: string, end_date: string) => {
        try {
            const response = await CartolaDepartmentAPI.generatePDF(iddepartment, start_date, end_date, idcompany)
            if (!response?.status) {
                CustomSnackbar('error', response.data.message)
                
                return false
            }

            return response.data
        } catch (error) {
            console.log(error)
            
            return false
        }
    }

    return {
        cartolaDepartments,
        selectedCartolaDepartment,
        status,
        totalRows,
        getCartolaDeparments,
        generatePDF
    }
}